import type { components } from "../api/schema";
import { apiClient } from "./apiClient";
import { ApiRequestError } from "./errors";
import { MAX_PAGE_SIZE } from "./pagination";

type Persona = components["schemas"]["PersonaResponse"];
type Scenario = components["schemas"]["ScenarioResponse"];

async function fetchAllForAgent<Item>(
  agentId: string,
  path: "/v1/personas" | "/v1/scenarios",
  signal?: AbortSignal,
): Promise<Item[]> {
  const items: Item[] = [];
  let pageToken: string | undefined;
  do {
    const { data, error } = await apiClient.GET(path, {
      signal,
      params: {
        query: {
          agent_id: agentId,
          page_size: MAX_PAGE_SIZE,
          page_token: pageToken,
        },
      },
    });
    if (error) throw new ApiRequestError(error);
    items.push(...(data.items as Item[]));
    pageToken = data.next_page_token ?? undefined;
  } while (pageToken);
  return items;
}

export function fetchAllVariablePersonas(
  agentId: string,
  signal?: AbortSignal,
): Promise<Persona[]> {
  return fetchAllForAgent<Persona>(agentId, "/v1/personas", signal);
}

export function fetchAllVariableScenarios(
  agentId: string,
  signal?: AbortSignal,
): Promise<Scenario[]> {
  return fetchAllForAgent<Scenario>(agentId, "/v1/scenarios", signal);
}
